exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-page-page-tsx": () => import("./../../../src/templates/page/page.tsx" /* webpackChunkName: "component---src-templates-page-page-tsx" */)
}

